/**
 * Convert the file size to MB
 * @param {number} size - Size to be converted
 * @returns {number} - Size in MB
 */
export function getFileSizeMB(size: number): number {
    return size / (1000 * 1000)
}

/**
 * Check if the file uploaded has an allowed file type
 * @param {File} file - The File object
 * @param {string[]} allowedTypes - Allowed file extensions (without the dot)
 * @returns {boolean} - True if the file type is allowed, otherwise false
 */
export function isFileTypeAllowed(file: File, allowedTypes: string[]): boolean {
    const fileExtension = file.name.split('.').pop()?.toLowerCase() ?? ''
    return allowedTypes.includes(fileExtension)
}

/**
 * Get the accepted file extensions for the "accept" attribute
 * @param {string[]} allowedTypes - Allowed file extensions (without the dot)
 * @returns {string} - Comma-separated list of extensions with dots
 */
export function getAcceptedExtensions(allowedTypes: string[]): string {
    return allowedTypes
        ? allowedTypes.map((type) => `.${type.toLowerCase()}`).join(',')
        : ''
}

export const readFileContent = <T>(file: File): Promise<T> => {
    return new Promise<T>((resolve, reject) => {
        const reader = new FileReader()

        reader.onload = (e) => {
            try {
                const content = e.target?.result
                // Assuming the file is JSON, parse it.
                const jsonData = JSON.parse(content as string)
                resolve(jsonData)
            } catch (err) {
                reject('Invalid JSON file')
            }
        }

        reader.onerror = () => reject('Error reading file')

        reader.readAsText(file)
    })
}
